import { api } from "./client";
import type { Battle, BattleType, PlayerItem, AutoBattleMode } from "../types";

interface ClaimResponse {
  battle_id: number;
  result: string;
  rewards: { gold: number; xp: number; diamonds: number };
  dropped_items?: PlayerItem[];
  info_messages?: string[];
}

export const battleApi = {
  start: (battle_type: BattleType = "PVE", stage_id?: number, auto_battle_mode?: AutoBattleMode) =>
    api.post<Battle>("/battle/start", { battle_type, stage_id, auto_battle_mode }),

  get: (id: number) => api.get<Battle>(`/battle/${id}`),

  claim: (battle_id: number) =>
    api.post<ClaimResponse>(`/battle/claim?battle_id=${battle_id}`),
};
